import { Component } from "react";
import axios from "./api.service";

export default class AudioService extends Component {
	static async createAudio(audio) {
		let form = new FormData();
		form.append("title", audio.title);
		form.append("unity", audio.unity);
		form.append("audio", audio.audio);

		return axios.post(`/audio/create`, form, {
			header: { "Content-Type": "multipart/form-data" },
		});
	}

	static async listAllAudios() {
		return axios
			.get(`/audio/getAll`)
			.then((res) => {
				return res.data;
			})
			.catch((err) => {
				return [];
			});
	}

	static async listOneAudio(id) {
		return axios
			.get(`/audio/getOne/${id}`)
			.then((res) => {
				return res.data.audios.audios;
			})
			.catch((err) => console.error);
	}

	static async updateAudio(id, audio) {
		let form = new FormData();
		form.append("title", audio.title);
		form.append("unity", audio.unity);
		if (audio.audio !== "") form.append("audio", audio.audio);

		return axios.put(`/audio/edit/${id}`, form, {
			header: { "Content-Type": "multipart/form-data" },
		});
	}

	static async deleteAudio(id) {
		return axios.delete(`/audio/delete/${id}`);
	}
}
